import InterviewPromoCard from './InterviewPromoCard';
import SidebarWeeklyHeatmap from './SidebarWeeklyHeatmap';
import SidebarAchievements from './SidebarAchievements';
import QuickAccessGrid from './QuickAccessGrid';

/**
 * DashboardSidebar — 320px-equivalent (1/3-column) sidebar: interview promo,
 * heatmap, achievements and quick links (Panel redesign order).
 *
 * Props:
 *   weeklyData         — array of { date, lessons, minutes }
 *   achievements       — array of achievement objects (empty while no badge endpoint is wired)
 *   user               — profile object (passed through if needed)
 *   showInterviewPromo — bool, only true when the student has real access to the cabin-crew
 *                        interview simulation (derived from existing /enrollments data — no new endpoint)
 *   primaryCourseId    — course_id of the primary enrollment, used by the "My Progress" quick link
 */
export default function DashboardSidebar({
  weeklyData = [],
  achievements = [],
  user: _user,
  showInterviewPromo = false,
  primaryCourseId = null,
}) {
  return (
    <aside
      className="flex flex-col gap-4"
      aria-label="Dashboard sidebar"
      data-testid="dashboard-sidebar"
    >
      {showInterviewPromo && <InterviewPromoCard />}
      <SidebarWeeklyHeatmap weeklyData={weeklyData} />
      <SidebarAchievements achievements={achievements} />
      <QuickAccessGrid variant="sidebar" courseId={primaryCourseId} />
    </aside>
  );
}
